<template>
  <div class="quiz-form">
    <div class="quiz-form__inner">
      <div class="quiz-input">
        <label v-if="label" for="description">
          {{ label }}
        </label>
        <textarea
          v-model="input"
          id="description"
          :placeholder="placeholder"
          rows="5"
        />
      </div>
      <div v-if="skip" class="quiz-skip" @click="$emit('next', 'don`t know')">
        <div>I don't know the cause of the problem, <br>Consultation is required.</div>
        <div>Skip question</div>
      </div>
    </div>
    <button class="quiz-btn" type="button" :disabled="!input.length" @click="$emit('next', input)">
      Next
    </button>
  </div>
</template>

<script>
export default {
  emits: ['next'],
  props: {
    skip: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Description'
    }
  },
  data() {
    return {
      input: ''
    }
  },
}
</script>